class windowOpener {
  static notifyOpener (key) {
    // TODO: Update origin to allow only the current domain.
    window.opener.postMessage(key, '*')
  }

  static listenToPopUpMessage (key, callback) {
    window.onmessage = (e) => {
      if (e.data === key) {
        callback()
      }
    }
  }
}

export default windowOpener
